/**
 * Centralised auth-gate copy for the Discover page.
 * Each message is tailored to the action the user tried to perform.
 */
export const AUTH_MESSAGES = {
    QUIZ:       "Create your Aluvo account to verify this title and earn your first coin.",
    WATCHLIST:  "Sign up to save this to your watchlist and start building your verified collection.",
    FOLLOW:     "Create an account to follow collectors and build your own verified movie & TV profile.",
    REACT:      "Sign up to react to achievements and join the Aluvo community.",
    COLLECTION: "Create your Aluvo account to start earning coins and unlocking collections.",
    MY_LISTS:   "Create an account to save custom lists.",
    RATING:     "Create a free account to rate movies.",
};